import enGB from './lux/en-GB.json';
import deCH from './lux/de-CH.json';

export default {
  'en-GB': enGB,
  'de-CH': deCH,
};
